import React from 'react';
import {
  BrowserRouter as Router, Route, Redirect, Switch,
} from 'react-router-dom';
import { getJumpPath } from '@utils';
import routerConfig from './config';

const NotFound = () => (<img src="https://img.tuguaishou.com/ips_gif_asset/15/54/90/26/23/08/08283ed4431512754a82ea92406d3d93.gif?auth_key=2205244800-0-0-27a7b0d833a3c87d41e2215651577827" alt="404" style={{ width: '100%', height: '812px' }} />);

const routes = () => (
  <div id="wrapElementMain">
    <Router basename="/drama_h5">
      <Switch>
        {
          Object.values(routerConfig).map((item, index) => <Route path={item.routerPath} exact component={item.asyComponent} key={index}></Route>)
        }

        <Route path="/" exact render={() => <Redirect to={getJumpPath('/home')}></Redirect>} key={-1} />

        <Route component={NotFound} />
      </Switch>
    </Router>
  </div>
);

export default routes;
